import { SiriusBaseComponent } from 'sirius-framework';
import { ViewChild, Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { SharedModel } from '../../models/shared.model'
import { Subscription } from 'rxjs';
import { CommonService } from '../../service/shared.service';
import { SiteLanguageService, SITE_LANGUAGE_ENG } from '../../service/site-language.service';

/** String resource — boşsa Türkçe varsayılan */
const FOOTER_KEYS = {
    copyRight: 'yediEminFooterCopyRight',
    privacyPolicy: 'yediEminFooterPrivacyPolicy',
    personalData: 'yediEminFooterPersonalData',
    cookieInfo: 'yediEminFooterCookieInfo',
    termsOfUse: 'yediEminFooterTermsOfUse',
    termsOfPricing: 'yediEminFooterTermsOfPricing',
    callCenter: 'yediEminFooterCallCenter',
    aboutPage: 'yediEminFooterAboutPage',
    docNotFound: 'yediEminFooterDocNotFoundMessage',
    showAboutLinkValue: 'showAboutLinkValue',
    urlPrivacyPolicy: 'yediEminFooterUrlPrivacyPolicy',
    urlCallCenter: 'yediEminFooterUrlCallCenter',
    urlAbout: 'yediEminFooterUrlAbout',
    urlCookieInfo: 'yediEminFooterUrlCookieInfo',
    cookiePopupContent: 'yediEminCookiePopupContent'
};

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css']
})
export class FooterComponent extends SiriusBaseComponent<any> implements OnDestroy {

    copyRightText = '© 2026 QNB Bank A.Ş.';
    privacyPolicyText = 'Kişisel Verilerin Korunması';
    personalDataText = 'Gizlilik Politikası';
    cookieInfoText = 'Çerez Politikası';
    termsOfUse = 'Kullanım Koşulları';
    termsOfPricing = 'Ücret ve Bilgilendirme';
    callCenter = 'Çağrı Merkezi';
    aboutPage = 'Nasıl Kullanılır?';
    msgDocNotFound = 'İlgili doküman sistemde bulunamadı.';

    footerUrlPrivacyPolicy = 'https://www.qnb.com.tr/destek/gizlilik-politikasi';
    footerUrlCallCenter = 'https://www.qnb.com.tr/724-bankacilik/cagri-merkezi';
    footerUrlAbout = 'https://www.qnb.com.tr/guvenli-odeme-sistemi';
    footerUrlCookieInfo = 'https://www.qnb.com.tr/destek/cerez-politikasi';

    cookieinfoMessage: string;
    documentOpen: boolean = false;
    openDocumentId: string;
    docTitle: string; 
    @ViewChild('kvkkPopup') kvkkPopUp: any;
    @ViewChild('cookieinfoPopup') cookieinfoPopUp: any;
    kvkkTitle: string;
    kvkkMessage: string; 
    isLoggedIn: boolean = false;
    subscriptionLoggedId: Subscription;
    private langSub: Subscription;
    showAboutLink: boolean = false;

    constructor(
        private commonService: CommonService,
        private siteLanguage: SiteLanguageService,
        private router: Router,
    ) {
        super();
    }

    
    OnInit() {
        this.langSub = this.siteLanguage.languageCode$.subscribe(() => {
            this.loadFooterResourceStrings();
            const showAboutLinkValue = this.commonService.getStringResource(FOOTER_KEYS.showAboutLinkValue, '');
            this.showAboutLink = showAboutLinkValue === '1';
        });
        this.subscriptionLoggedId = this.commonService.isLoggedin.subscribe(state => {
            this.isLoggedIn = (state == true);
        });
    }

    ngOnDestroy() {
        if (this.langSub) {
            this.langSub.unsubscribe();
        }
        if (this.subscriptionLoggedId) {
            this.subscriptionLoggedId.unsubscribe();
        }
    }

    private loadFooterResourceStrings(): void {
        this.copyRightText = this.commonService.getStringResource(FOOTER_KEYS.copyRight, this.copyRightText);
        this.privacyPolicyText = this.commonService.getStringResource(FOOTER_KEYS.privacyPolicy, this.privacyPolicyText);
        this.personalDataText = this.commonService.getStringResource(FOOTER_KEYS.personalData, this.personalDataText);
        this.cookieInfoText = this.commonService.getStringResource(FOOTER_KEYS.cookieInfo, this.cookieInfoText);
        this.termsOfUse = this.commonService.getStringResource(FOOTER_KEYS.termsOfUse, this.termsOfUse);
        this.termsOfPricing = this.commonService.getStringResource(FOOTER_KEYS.termsOfPricing, this.termsOfPricing);
        this.callCenter = this.commonService.getStringResource(FOOTER_KEYS.callCenter, this.callCenter);
        this.aboutPage = this.commonService.getStringResource(FOOTER_KEYS.aboutPage, this.aboutPage);
        this.msgDocNotFound = this.commonService.getStringResource(FOOTER_KEYS.docNotFound, this.msgDocNotFound);
        this.footerUrlPrivacyPolicy = this.commonService.getStringResource(FOOTER_KEYS.urlPrivacyPolicy, this.footerUrlPrivacyPolicy);
        this.footerUrlCallCenter = this.commonService.getStringResource(FOOTER_KEYS.urlCallCenter, this.footerUrlCallCenter);
        this.footerUrlAbout = this.commonService.getStringResource(FOOTER_KEYS.urlAbout, this.footerUrlAbout);
        this.footerUrlCookieInfo = this.commonService.getStringResource(FOOTER_KEYS.urlCookieInfo, this.footerUrlCookieInfo);
        this.cookieinfoMessage = this.commonService.getStringResource(FOOTER_KEYS.cookiePopupContent, '');
    }
     
    OpenTermsOfPricing() { 
        let docList = this.commonService.publicDocList;
        if (docList) {
            this.openDocumentId = docList.ViewModelList[0].DocumentId;
            this.docTitle = docList.ViewModelList[0].Name;
            this.documentOpen = true;
        } else {
            console.log(this.msgDocNotFound);
        }
    }

    OpenTermsOfUse() {
        let docList = this.commonService.publicDocList;
        if (docList) {
            this.openDocumentId = docList.ViewModelList[1].DocumentId;
            this.docTitle = docList.ViewModelList[1].Name;
            this.documentOpen = true;
        }
        else {
            console.log(this.msgDocNotFound);
        }
    }

  OpenPrivacyPolicy() {

    this.kvkkTitle = this.commonService.getKvvkTitle();
     this.kvkkMessage = this.commonService.getStringResource(SharedModel.Kvkk, '');
     this.kvkkPopUp.open(this.kvkkTitle, this.kvkkMessage);
    }

    closeDocument(title: any) {
        this.documentOpen = false;
    }
    cancelDocument(title: any) {
        this.documentOpen = false;
    }

    OpenPrivacyPage() {
      window.open(this.footerUrlPrivacyPolicy, '_blank');
    }

  OpenCookieInfo() { 
      this.cookieinfoPopUp.open(this.cookieInfoText, this.cookieinfoMessage);
    }

    OpenCallCenter() {
      window.open(this.footerUrlCallCenter, '_blank');
    }

    OpenAbout() {
        if (this.siteLanguage.languageCode === SITE_LANGUAGE_ENG) {
            this.router.navigate(['/faq']);
            return;
        }
        window.open(this.footerUrlAbout, '_blank');
    }
    
}
